export enum CustomFilterEventType {
    Save = 'Save',
    ClearModel = 'ClearModel',
}
